/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { IToysrusImageViewProps } from './toysrus-image';

const ToysrusImageView: React.FC<IToysrusImageViewProps> = (props) => {
    const {
        toysrusImage,
      } = props;
    return (
       <React.Fragment>
            {toysrusImage} <br/>
            <h1>{props.resources.resourceKey}</h1><br/>
            <h2>{props.config.sampleString}</h2>
        </React.Fragment>
    );
};
export default ToysrusImageView;
